export default __webpack_public_path__ + "static/media/US3.1a2e93b5.png";